import { Avatar, Button, Card, Col, Collapse, Divider, Form, Input, Row, message, Modal, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import Dompurify from 'dompurify'
import "./index.css"
import HistoryModal from "../modals/history";
import PartialPaymentAPIService from "../../../services/api/partialPaymentService";
import SmartPayError from "../../error";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { RightOutlined, UserOutlined } from "@ant-design/icons";
import PoweredByEasebuzz from "../../../assets/images/powered_by_easebuzz.svg";

const PartialPaymentCard = () => {
    const [isFullAmount, setFullAmount] = useState(true)
    const [isPartialAmount, setPartialAmount] = useState(false)
    const [isHistoryModal, setHistoryModal] = useState(false)
    const [ppLinkData, setPPLinkData] = useState({})
    const [payAmount, setPayAmount] = useState(0)
    const [validatedAmount, setValidatedAmount] = useState(0)
    const [historyData, setHistoryData] = useState([])
    const [due_amount, setDueAmount] = useState()
    const [paid_amount, setPaidAmount] = useState()
    const [valid_transaction, setValidTransaction] = useState(true)
    const [logo_url, setLogo] = useState("")
    const [loading, setLoading] = useState(true);
    const [easycollectFields, setEasycollectFields] = useState()
    const [partialPaymentConfig, setPartialPaymentConfig] = useState({})
    const [border_partial, setBorderPartialBorder] = useState({ border: `1px solid ${partialPaymentConfig?.theme_color || "rgb(231, 233, 237)"}` })
    const [border_fullAmount, setFullamtBorder] = useState({ border: `2px solid ${partialPaymentConfig?.theme_color || "rgb(78, 95, 249)"}` })
    const [initialError, setError] = useState(false)
    const [visibleModalKey, setVisibleModalKey] = useState(null);

    const [form] = Form.useForm()
    const { url } = useParams();
    const { Panel } = Collapse;
    const isMobile = window.innerWidth <= 810;

    useEffect(() => {
        get_link_details();
    }, []);

    const handleFullAmountchange = (e) => {
        setFullAmount(true)
        setPartialAmount(false)
        setPayAmount(ppLinkData?.due_amount)
        setValidatedAmount(ppLinkData?.due_amount)
        setBorderPartialBorder({ border: `1px solid ${partialPaymentConfig?.theme_color || "rgb(241, 243, 247)"}` })
        setFullamtBorder({ border: `2px solid ${partialPaymentConfig?.theme_color || "rgb(78, 95, 249)"}` })
        form.resetFields()
    }

    const handlePartialAmountchange = (e) => {
        setPartialAmount(true)
        setFullAmount(false)
        setBorderPartialBorder({ border: `2px solid ${partialPaymentConfig?.theme_color || "rgb(78, 95, 249)"}` })
        setFullamtBorder({ border: `1px solid ${partialPaymentConfig?.theme_color || "rgb(241, 243, 247)"}` })
    }

    const get_link_details = async () => {
        await PartialPaymentAPIService.get_link_details(url).then((response) => {
            if (response.success) {
                const data = response.data
                setEasycollectFields(data.easycollect_fields)
                setPartialPaymentConfig(data.easycollect_fields?.partial_payment_config)
                setLogo(response?.m_logo)
                setPPLinkData(data)
                setPayAmount(data.due_amount)
                setValidatedAmount(data.due_amount)
                setDueAmount(data.due_amount)
                setPaidAmount(data.paid_amount)
                setValidTransaction(true)
            }
            else {
                setError(response?.message)
                setPPLinkData(response)
                setValidTransaction(false)
            }
        }).catch((error) => {
            setError("Not Found")
        })
        setLoading(false)
    }

    const get_payment_history = async () => {
        let queryData = { hash_url: ppLinkData?.hash_url }
        const response = await PartialPaymentAPIService.get_payment_history(queryData)
        if (response.success) {
            setHistoryData(response.data)
            setHistoryModal(true)
        }
    }

    const save_link_details_on_confirmation = () => {
        const fieldsToSave = partialPaymentConfig?.pre_payment?.save_fields || {};
        const results = {};
        Object.entries(fieldsToSave).forEach(([key, fieldName]) => {
            results[key] = form.getFieldsValue()[fieldName]
        });
        return results;
    }

    const pay_amount_backend = async () => {
        let queryData = {
            hash_param: url,
            email: ppLinkData?.email,
            partial_amount: payAmount,
            save_details: save_link_details_on_confirmation()
        }
        const response = await PartialPaymentAPIService.pay_amount(queryData)
        if (response.success) {
            if (response.is_hosted)
                window.open(response.link, "_self")
            else {
                const hash_key_merchant = ppLinkData?.hash_m_key.slice(3, -3)
                const easebuzzCheckoutClass = window.EasebuzzCheckout;
                var easebuzzCheckout = new easebuzzCheckoutClass(hash_key_merchant, process.env.REACT_APP_ENV)
                var options = {
                    access_key: response?.access_key, // access key received via Initiate Payment
                    theme: "#123456", // color hex
                    onResponse: (response) => {
                        var form = document.createElement("form");
                        form.method = "POST";
                        // var url_type = response.status === "success" ? 'surl' : 'furl';
                        form.action = process.env.REACT_APP_PARTIAL_PAYMENT_URL + "partial-payment/response/" + url + "/";
                        Object.keys(response).forEach((key) => {
                            var element = document.createElement("input");
                            element.type = "hidden";
                            element.name = key;
                            element.value = response[key];
                            form.appendChild(element)
                        });
                        document.body.appendChild(form);
                        form.submit();
                    }
                }
                easebuzzCheckout.initiatePayment(options);
            }
        }
        else {
            message.error(response.message)
        }
    }

    const getFirstNameInfo = () => (
        <div className="gap-1">
            <p className="batch fs-20"><b>   Hi {ppLinkData?.firstname},</b></p>
            <p className="batch fs-18 mb-10">Please confirm your information</p>
        </div>
    )

    const getDisplayFields = () => {
        const contactFields = [
            { key: "email", label: "Email ID" },
            { key: "phone", label: "Phone" },
            { key: "udf1", label: "UDF1" },
            { key: "udf2", label: "UDF2" },
            { key: "udf3", label: "UDF3" },
            { key: "udf4", label: "UDF4" },
            { key: "udf5", label: "UDF5" },
            { key: "expiry_date", label: "Expiry Date"}
        ];
        const selectedKeyMapper = partialPaymentConfig?.pre_payment?.default_selected || {email:true, phone:true, udf1:true, udf2:true, udf3:true, udf4:true, udf5:true}
        const fields = contactFields.filter((k) => selectedKeyMapper[k.key])
        return fields.map(({ key, label }) => {
            const keyMapper = easycollectFields?.mapping;
            const keyName = keyMapper?.[key] || label;
            if (ppLinkData?.[key]) {
                return (
                    <div className="gap" key={key}>
                        <p className="batch fs-14 key-text-color">{keyName}</p>
                        <p className="batch text">{ppLinkData?.[key]}</p>
                    </div>
                );
            }
            return null;
        });
    };

    const getFormDetails = () => {
        if (ppLinkData.payment_made) {
            return (
                <div>
                    <div style={{ margin: "0px auto", width: "100px", textAlign: "center", paddingTop: "82px" }}>
                        <lottie-player
                            src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/Success.json"
                            style={{ width: "5" }} background="transparent" speed="1" loop={false} autoplay />
                    </div>
                    <h3 style={{ textAlign: "center" }}>Payment on this link has been done</h3>
                </div>
            )
        }
        else {
            return (
                <Form
                    form={form}
                    onFinish={pay_amount_backend}
                    className="payment-form"
                >
                    <h4 className="select-type">Select Payment Type</h4>
                    <Form.Item style={border_fullAmount}>
                        <div className="upi-options" onClick={handleFullAmountchange}>
                            <div className="d-flex align-items-center">
                                <span className="upi-label"><b>Pay Full Amount</b></span>
                                <Input
                                    className="upi-type-select"
                                    type="radio"
                                    name="upitype"
                                    value="app"
                                    checked={isFullAmount}
                                    label="Pay in full"
                                    onChange={handleFullAmountchange}
                                    style={{
                                        cursor: "pointer",
                                        accentColor: partialPaymentConfig?.theme_color
                                    }}
                                />
                            </div>
                        </div>
                    </Form.Item>
                    <Form.Item style={border_partial} name="partial_amount"
                        rules={[{ required: isPartialAmount, message: 'Please Enter amount to be paid', }, () => ({
                            validator(_, pay_amount) {
                                const regexPattern = /^\d+(\.\d{1,2})?$/
                                if (payAmount && !(regexPattern.test(payAmount)))
                                    return Promise.reject("Enter valid amount")
                                else if (payAmount && payAmount > due_amount)
                                    return Promise.reject("Amount can't be greater than due amount");
                                else if (payAmount && !(payAmount >= 1))
                                    return Promise.reject("Amount should be greater than equal 1");
                                else
                                    setValidatedAmount(payAmount)
                                return Promise.resolve();
                            }
                        })]}
                    >
                        <div className="upi-options" onClick={handlePartialAmountchange}>
                            <div className="d-flex align-items-center">
                                <span className="upi-label">
                                    <b>Pay Partial Amount</b>
                                </span>
                                <Input
                                    className="upi-type-select"
                                    type="radio"
                                    name="upitype"
                                    checked={isPartialAmount}
                                    onChange={handlePartialAmountchange}
                                    style={{
                                        cursor: "pointer",
                                        accentColor: partialPaymentConfig?.theme_color
                                    }}
                                />
                            </div>
                            <div className="vpa-div">
                                <div className="sc-19dei4g-0 TNKLH" type="text">
                                    <div className="input-field">
                                        <Input
                                            placeholder="Enter Payment Amount"
                                            className="custom-input ab"
                                            hidden={!isPartialAmount}
                                            onChange={(e) => setPayAmount(e.target.value)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form.Item>
                    {renderDynamicFields()}
                    {renderComplianceField()}
                    <Form.Item>
                        <Button
                            block
                            className="pay"
                            htmlType="submit"
                            style={{
                                background: partialPaymentConfig?.theme_color || "#4E5FF9",
                                fontSize: "20px",
                                color: "#fff",
                                marginTop: "15px"
                            }}
                        >
                            <b>
                                <img
                                    src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/download.png"
                                    style={{ width: "width: 100%", height: "auto" }} alt=""
                                /> Pay &#8377; {validatedAmount} 
                            </b>
                        </Button>
                    </Form.Item>
                </Form>
            )
        }
    }

    const RenderComplianceModal = () => {
        const section = partialPaymentConfig?.pre_payment?.compliance_section?.action_config;
        const actionConfig = section?.actions[visibleModalKey]
        const styleConfig = section?.style;
        return (
            <Modal
                open={!!visibleModalKey}
                onCancel={() => setVisibleModalKey(null)}
                footer={null}
                title={
                    <div style={styleConfig?.title}>
                        {actionConfig?.label}
                    </div>
                }
                getContainer={false}
                style={styleConfig?.modal}
                width={800}
                bodyStyle={styleConfig?.body}
            >
                <div style={styleConfig?.content}
                    dangerouslySetInnerHTML={{
                        __html: Dompurify.sanitize(actionConfig?.content || "<p>Content not found.</p>"),
                    }}
                />
            </Modal>
        )
    }

    const renderComplianceField = () => {
        const section = partialPaymentConfig?.pre_payment?.compliance_section;
        const actions = section?.action_config?.actions || {};
        const actionEntries = Object.entries(actions);

        if (!section) return null;
        return (
            <Form.Item
                name={section.name}
                valuePropName="checked"
                rules={[{
                    validator: (_, checked) => {
                        if (checked === true)
                            return Promise.resolve();
                        return Promise.reject(
                            new Error(section.error_msg || "You must agree to proceed")
                        );
                    }
                }]}
            >
                <Checkbox>
                    <span>{section.label}</span>{" "}
                    {actionEntries.map(([key, action], index) => {
                        const isLast = index === actionEntries.length - 1;
                        const isSecondLast = index === actionEntries.length - 2;
                        return (
                            <React.Fragment key={key}>
                                <span
                                    className="fs-14 link-details-text-color"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();

                                        if (action.action_type === "modal")
                                            setVisibleModalKey(key);
                                        else if (action.action_type === "link")
                                            window.open(action.url, "_blank");
                                    }}
                                    style={{
                                        color: partialPaymentConfig?.theme_color,
                                        cursor: "pointer"
                                    }}
                                >
                                    {action.label}
                                </span>

                                {!isLast && (
                                    <span>
                                        {isSecondLast ? " and " : ", "}
                                    </span>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Checkbox>
            </Form.Item>
        );
    };

    const renderDynamicFields = () => {
        return partialPaymentConfig?.pre_payment?.extra_fields?.map((field, index) => {
            return (
                <Form.Item
                    key={index}
                    name={field.name}
                    rules={[{ required: field.required, message: field.error_msg }]}
                >
                    <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                        <span style={{ fontWeight: "600" }}>{field.label}</span>
                        <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center' }}>
                        {field.options.map((opt, i) => (
                            <label key={i} style={{ marginLeft: "10px" }}>
                            <Input
                                type={field.type}
                                name={field.name}
                                value={opt.value}
                                style={{ marginRight: "5px", accentColor: partialPaymentConfig?.theme_color }}
                            />
                            {opt.label}
                            </label>
                        ))}
                        </div>
                    </div>
                </Form.Item>
            )
        });
    };

    const renderPageDetails = () => {
        if (Object.keys(ppLinkData).length !== 0 && valid_transaction) {
            return (
                <div className={isMobile ? "mobile-main-section" : "main-section"}>
                    <Card
                        style={{ borderRadius: "10px", padding: "0px !important" }}
                        className={isMobile ? "mobile-wrapper" : "wrapper"}
                    >
                        <Row align="middle" className="card-header" style={{ background: partialPaymentConfig?.theme_color, color: partialPaymentConfig?.text_color }}>
                            {logo_url && (
                                <Col xl={{ span: 4 }} lg={{ span: 4 }} xs={{ span: isMobile ? 12 : 6 }} className="avatar">
                                    <Avatar src={logo_url} shape="square" className="partial-pre-payment-avatar" icon={<UserOutlined />} />
                                </Col>
                            )}
                            <Col xl={{ span: 12 }} lg={{ span: 12 }} xs={{ span: isMobile ? 24 : 12 }} className="d-flex merchant-data">
                                <p className="merchant-name mt-0">Paying <b>{ppLinkData?.merchant_name}</b></p>
                                <p className="total-text">
                                    {partialPaymentConfig?.pre_payment?.totalAmtalias || "Total"} : &#8377;  {parseFloat(ppLinkData?.amount).toLocaleString('en-US')}
                                </p>
                            </Col>
                            <Col xl={{ span: 6 }} lg={{ span: 6 }} xs={{ span: 24 }} className={`custom-col ${isMobile ? "jce" : "jcc"}`}>
                                <div className="due-amount">
                                    <p className="batch-up">
                                        <span style={{ fontSize: "15px", color: partialPaymentConfig?.text_color || "#000" }}>Due :</span>     &#8377; {parseFloat(due_amount).toLocaleString('en-US')}
                                    </p>
                                </div>
                                <div className="paid-details">
                                    <p className="batch-down">
                                        <span style={{ fontSize: "15px", color: partialPaymentConfig?.text_color || "#000" }}>Paid :</span>  &#8377; {parseFloat(paid_amount).toLocaleString('en-US')}
                                    </p>
                                    <a
                                        onClick={get_payment_history}
                                        className={isMobile ? "payment-history-mobile" : "payment-history-desktop"}
                                        style={{
                                            border: "0px",
                                            textDecoration: "underline",
                                            fontSize: "15px",
                                            color: partialPaymentConfig?.text_color || "rgb(78, 95, 249)",
                                        }}
                                    >
                                        Payment History <RightOutlined style={{ fontSize: "11px", color: partialPaymentConfig?.text_color || 'rgb(78, 95, 249)' }} />
                                    </a>
                                </div>
                            </Col>
                        </Row>
                        <Row className="card-body scrollable-card-body">
                            <Col span={11} lg={11} xs={24}>
                                {isMobile ?
                                    <Collapse ghost className="collapse-mobile" expandIconPosition="right" accordion>
                                        <Panel header={getFirstNameInfo()} key="1">
                                            {getDisplayFields()}
                                        </Panel>
                                    </Collapse>
                                    :
                                    <>
                                        {getFirstNameInfo()}
                                        {getDisplayFields()}
                                    </>
                                }
                            </Col>
                            <Divider type={isMobile ? "horizontal" : "vertical"} className="divider-line" style={{margin: isMobile && "0px 0px 15px", height: isMobile ? "0vh" : "48vh"}} />
                            <Col span={11} lg={11} xs={24}>
                                {getFormDetails()}
                            </Col>
                            {partialPaymentConfig?.pre_payment?.footer?.required && partialPaymentConfig?.pre_payment?.footer?.content &&
                                <>
                                    <Divider type="horizontal" />
                                    <Col span={24}>
                                    <div dangerouslySetInnerHTML={{ __html: Dompurify.sanitize(partialPaymentConfig?.pre_payment?.footer?.content) }} />
                                    </Col>
                                </>
                            }
                        </Row>
                    </Card>
                    <Row className="flex-container mt-20">
                        <Col xl={{ span: 16 }} lg={{ span: 16 }} xs={{ span: 24 }} className={isMobile ? "support-mobile" : "support-desktop"}>
                            <p style={{color: "#7A8699"}}>For any queries, please contact us at <a href="mailto:support@easebuzz.in">support@easebuzz.in</a></p>
                        </Col>
                        <Col xl={{ span: 8 }} lg={{ span: 8 }} xs={{ span: 24 }} className={isMobile? "centered-logo" : "powered-by-easebuzz"}>
                            <img src={PoweredByEasebuzz} alt="Powered By Easebuzz" />
                        </Col>
                    </Row>
                    <RenderComplianceModal />
                    <HistoryModal isHistoryModal={isHistoryModal} setHistoryModal={setHistoryModal} historyData={historyData} />
                </div>
            )
        }
        else if (initialError) {
            return <SmartPayError status={500} title={ppLinkData?.message} errorMsg="Either we made a mistake or you are looking for something else" />
        }
    }

    return (
        <>
            {renderPageDetails()}
        </>
    )
}
export default PartialPaymentCard;